import React, { useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { sessionIdState, showReviewState, userHasReviewedState } from './states';
import './Review.css';
import { submitReview } from './services/ReviewService';


const Review = ({ title }: { title: string }) => {

  const [showReview, setShowReview] = useRecoilState(showReviewState);
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const sessionId = useRecoilValue(sessionIdState);
  const userHasReviewed = useSetRecoilState(userHasReviewedState);

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target instanceof Element && e.target.classList.contains('modal-overlay')) {
      setShowReview(false);
    }
  };

  const handleStarClick = (value: number) => {
    setRating(value);
  };

  const handleTextAreaChange = (value: string) => {
    setFeedback(value);
  }

  const closeReviewModal = () => {
    setShowReview(false);
  };

  const handleSubmitReview = (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault();
    submitReview(feedback, rating, sessionId).then(resp => {
      userHasReviewed(true);
      closeReviewModal();
      setFeedback("");
      setRating(0);
    })
  }

  return showReview ? (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h2>{title}</h2>
        </div>
        <div className="modal-body">
          <div className="review-container">
            <h6 className="subtitle">Thank you for using the Diagnostic AI. Please take a second to give us your feedback!</h6>
            <hr style={{ marginTop: 20, marginBottom: 20 }} />
            <h6 className="subtitle">What is your overall satisfaction?</h6>
            <div className="stars">
              {[...Array(5)]?.map((star, index) => (
                <span
                  key={index}
                  className={index < rating ? 'star selected' : 'star'}
                  onClick={() => handleStarClick(index + 1)}
                >
                  {index < rating ? '★' : '☆'}
                </span>
              ))}
            </div>
            <hr style={{ marginTop: 20, marginBottom: 20 }} />
            <h6 className="subtitle">Any additional feedback?</h6>
            <textarea
              className="review-input"
              placeholder="Feedback..."
              value={feedback}
              onChange={e => handleTextAreaChange(e.target.value)}
            ></textarea>
            {/* <hr style={{ marginTop: 10, marginBottom: 20 }} />
            <h6 className="subtitle">Your Email Address</h6>
            <input
              type="email"
              className="email-input"
              placeholder="example@mail.com"
            /> */}
            <div>
              <button className="submit-button" onClick={handleSubmitReview}>Submit</button>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          {/* <button onClick={onClose}>Close</button> */}
        </div>
      </div>
    </div>
  ) : null;
};

export default Review;
